import React, { Fragment } from 'react';
import { Tabs, Row, Col, Table, Button, Divider } from 'antd';
import {
  FileTextOutlined,
  FileSearchOutlined,
  HistoryOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import { PetitionsRequest } from '../../types/petitions-response';
import { CustomButton, CustomTable, CustomText } from '../../../../components';

interface GoodsDetailViewProps {
  detailData?: PetitionsRequest;
  setFooterLeft: (footer: React.ReactNode) => void;
  onVoucher?: () => void;
  onDocuments: (id: string[]) => void;
}

const GoodsDetailView: React.FC<GoodsDetailViewProps> = ({
  detailData,
  setFooterLeft,
  onVoucher,
  onDocuments,
}) => {
  // FOOTER
  React.useEffect(() => {
    setFooterLeft(
      <Fragment>
        <CustomButton
          label={'Descargar documentos'}
          disabled={detailData?.documents && detailData.documents.length === 0}
          onClick={() => {
            const documentIds = detailData?.documents
              ?.map((doc) => doc.id)
              .filter((id): id is string => id !== undefined);
            onDocuments(documentIds || []);
          }}
          icon={<DownloadOutlined />}
          size="middle"
          buttonType={'secondary'}
        />
      </Fragment>
    );
  }, [setFooterLeft]);

  const documentColumns = [
    {
      title: 'Id',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Fecha creación',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: 'Archivo',
      dataIndex: 'link',
      key: 'link',
      render: (link: string) => (
        <Button type="link" href={link} target="_blank">
          Descargar
        </Button>
      ),
    },
  ];

  return (
    <Fragment>
      <Tabs
        defaultActiveKey="1"
        items={[
          {
            key: '1',
            label: (
              <Button type="link" icon={<FileTextOutlined />}>
                Información general
              </Button>
            ),
            children: (
              <Fragment>
                <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                  <Col span={8}>
                    <div className="mb-4">
                      <CustomText text="Ticket:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.ticket || 'No especificado'}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4">
                      <CustomText text="Tipo ticket:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.ticket_type || 'No especificado'}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4">
                      <CustomText text="Fecha:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.query_date || 'No especificado'}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4">
                      <CustomText text="Status:" strong fontSize="small" />
                      <CustomText
                        text={detailData?.status_id || 'No especificado'}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-4">
                      <CustomText
                        text="Nuevo responsable:"
                        strong
                        fontSize="small"
                      />
                      <CustomText
                        text={detailData?.new_responsible || 'No especificado'}
                        fontSize="middle"
                      />
                    </div>
                  </Col>
                </Row>
              </Fragment>
            ),
          },
          {
            key: '2',
            label: (
              <Button type="link" icon={<FileSearchOutlined />}>
                Documentos
              </Button>
            ),
            children: (
              <>
                <Table
                  dataSource={detailData?.documents?.map((doc, index) => ({
                    key: index,
                    createdAt: doc.created_at,
                    name: doc.url?.split('/').pop(),
                    link: doc.url,
                  }))}
                  columns={documentColumns}
                />
                <Divider />
              </>
            ),
          },
          {
            key: '3',
            label: (
              <Button type="link" icon={<HistoryOutlined />}>
                Historial de la solicitud
              </Button>
            ),
            children: (
              <CustomTable
                columns={[
                  {
                    title: 'Id',
                    dataIndex: 'index',
                    key: 'index',
                    render: (_: any, __: any, index: number) => index + 1,
                  },
                  {
                    title: 'Fecha de solicitud',
                    dataIndex: 'date',
                    key: 'date',
                  },
                  {
                    title: 'Estado',
                    dataIndex: 'comment',
                    key: 'comment',
                  },
                ]}
                dataSource={detailData?.history?.map((item, index) => ({
                  key: index,
                  date: item.date,
                  comment: item.comment,
                }))}
                pagination={false}
              />
            ),
          },
        ]}
      />
    </Fragment>
  );
};

export default GoodsDetailView;
